import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import type { TableColumnsType } from "antd";
import { Form, Modal, notification, Progress, Spin } from 'antd';
import useSWR, { mutate } from 'swr';
import { useAuth } from "../context/AuthContext";

function StartLicense(stimulsoftInstance: any) {
    const key = process.env.REACT_APP_STIMULSOFT_LICENSE_KEY;
    if (key && key.trim() !== "") {
        try {
            stimulsoftInstance.Base.StiLicense.key = key.trim();
        } catch (error: any) { }
    } else {
        const hardcodedKey = "6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHmKmIYtQbGVffUafn4grxXukjNz+mLI/d2lO8A9DuHxAxu4MmrN4lqhtklB0Pcnfq+AIk+1s6kU0D6JIIxpfQs1FV6pzwrzAWDLexRPvVgpswR/C5n69gFjFmWmtV0bGCTAj6H/MHgwElWYT9nYccmuFH0sfAj7VELa2HehqREJ7di+05AWeWIScfcWsf0XZ3JK+2X3reYvhUEAxrCwX3FDw2p1hPQIfiUVkUd4NRvfwWBLOjP2ZTfp9dzNe1D6T7miK1VBd731o/ex6q1bkdNH+G1KV6OLxdQwb9zWr4AR0QtMKwrphskgAYb5PMCectoVCeRFKtWSm8qnMP+GN8v0GHbJGQ/ZYWMAsE94nCEhnJz9T/xfy1b6WEWqpUUjVsfPzm/naRz0bxVN+AtFW7thTBMwGXoKTJXnKhfrI5u/fRffUu78ejnazBjWCHANN/xF7XOLhnFWw5JZHPXkaoCbiG8kBL3bgL4DtSyZ7jecAPmJUtainwLNMdo75J6hvu/pS+jDUs2tqRjEv6PTehXg";
        try {
            stimulsoftInstance.Base.StiLicense.key = hardcodedKey;
        } catch (fallbackError: any) { }
    }
}

export interface TableListPartInvoice {
    id: React.Key;
    type: string;
    jobType: string;
    itemNo: string;
    description: string;
    qty: number;
    uom: string;
    price: number;
    discPercent: string | number;
    discAmount: number;
    total: number;
    status: string;
    invoiceReturnNo: string;
    hpp?: string;
}

interface AddressOption {
    value: string;
    label: string;
}

interface CustomerType {
    code: string;
    deskripsi: string;
}

interface IdType {
    code: string;
    deskripsi: string;
}

interface VatTransType {
    code: string;
    deskripsi: string;
}

interface PpnType {
    value: string;
}

const fetcher = (url: string) => axios.get(url).then((res) => res.data);
interface WarehouseType {
    warehouse_code: string;
    warehouse_name: string;
}

interface SalesTopType {
    code: string;
    deskripsi: string;
}

interface SparepartsBrandType {
    code: string;
    description: string;
}

const parseIndonesianNumber = (value: any): number => {
    if (typeof value === 'number') {
        return value;
    }
    if (typeof value === 'string') {
        const cleanedValue = value.replace(/\./g, '').replace(/,/g, '.');
        return parseFloat(cleanedValue) || 0;
    }
    return 0;
};

const parseDecimalNumber = (value: any): number => {
    if (typeof value === 'number') return value;
    if (typeof value === 'string') {
        return parseFloat(value.replace(/,/g, '.')) || 0;
    }
    return 0;
};

const calculateDueDate = (invoiceDateStr: string, topValue: any): string => {
    if (!invoiceDateStr) return "";
    let parsedDate = new Date();
    const months: { [key: string]: number } = {
        "Januari": 0, "Februari": 1, "Maret": 2, "April": 3,
        "Mei": 4, "Juni": 5, "Juli": 6, "Agustus": 7,
        "September": 8, "Oktober": 9, "November": 10, "Desember": 11
    };
    if (invoiceDateStr.includes('/')) {
        const parts = invoiceDateStr.split('/');
        if (parts.length === 3) {
            const day = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10) - 1;
            const year = parseInt(parts[2], 10);
            parsedDate = new Date(year, month, day);
        }
    } else {
        const parts = invoiceDateStr.split(' ');
        if (parts.length === 3) {
            const day = parseInt(parts[0], 10);
            const month = months[parts[1]];
            const year = parseInt(parts[2], 10);
            if (month !== undefined) parsedDate = new Date(year, month, day);
        }
    }
    if (isNaN(parsedDate.getTime())) return "";
    const matches = String(topValue || "").match(/\d+/);
    const daysToAdd = matches ? parseInt(matches[0], 10) : 0;
    parsedDate.setDate(parsedDate.getDate() + daysToAdd);
    const dd = String(parsedDate.getDate()).padStart(2, '0');
    const mm = String(parsedDate.getMonth() + 1).padStart(2, '0');
    const yyyy = parsedDate.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
};

export const STATUS_MAP: Record<string, string> = { "1": "Draft", "22": "Active", "6": "Closed", "4": "Complete", "3": "Waiting for Approved", "5": "Cancel" };
export const REVERSE_STATUS_MAP: Record<string, string> = { "Draft": "1", "Active": "22", "Closed": "6", "Complete": "4", "Waiting for Approved": "3", "Cancel": "5" };
export const getWarehouseLabel = (warehouse: string): string => {
    const map: Record<string, string> = {
        "WH_AMP_SPT": "Sampit",
        "WH_AMP_TWH": "Teweh",
        "WH_AMP_PKY": "Palangkaraya",
        "WH_AMP_PBUN": "Pangkalanbun",
    };
    return map[warehouse] || warehouse || "-";
};
function terbilang(nilai: number): string {
    function keKata(val: number): string {
        const bilangan = [
            "", "Satu", "Dua", "Tiga", "Empat", "Lima",
            "Enam", "Tujuh", "Delapan", "Sembilan", "Sepuluh", "Sebelas"
        ];

        let temp = "";
        const n = Math.floor(val);
        if (n < 12) {
            temp = " " + bilangan[n];
        } else if (n < 20) {
            temp = keKata(n - 10) + " Belas";
        } else if (n < 100) {
            temp = keKata(n / 10) + " Puluh" + keKata(n % 10);
        } else if (n < 200) {
            temp = " Seratus" + keKata(n - 100);
        } else if (n < 1000) {
            temp = keKata(n / 100) + " Ratus" + keKata(n % 100);
        } else if (n < 2000) {
            temp = " Seribu" + keKata(n - 1000);
        } else if (n < 1000000) {
            temp = keKata(n / 1000) + " Ribu" + keKata(n % 1000);
        } else if (n < 1000000000) {
            temp = keKata(n / 1000000) + " Juta" + keKata(n % 1000000);
        } else if (n < 1000000000000) {
            temp = keKata(n / 1000000000) + " Milyar" + keKata(n % 1000000000);
        } else if (n < 1000000000000000) {
            temp = keKata(n / 1000000000000) + " Trilyun" + keKata(n % 1000000000000);
        }
        return temp;
    }
    if (nilai === 0) return "Nol Rupiah";
    return (keKata(nilai).trim() + " Rupiah").replace(/\s+/g, " ");
}

export const withWorkOrderInvoice = (Component: React.ComponentType<any>) => {
    return (props: any) => {
        const [form] = Form.useForm();
        const location = useLocation();
        const { userData } = useAuth();
        const [isModalVisible, setIsModalVisible] = useState(false);
        const [provinces, setProvinces] = useState<AddressOption[]>([]);
        const [regencies, setRegencies] = useState<AddressOption[]>([]);
        const [kecamatans, setKecamatans] = useState<AddressOption[]>([]);
        const [kelurahans, setKelurahans] = useState<AddressOption[]>([]);
        const [loadingProvinces, setLoadingProvinces] = useState(false);
        const [loadingRegencies, setLoadingRegencies] = useState(false);
        const [loadingKecamatans, setLoadingKecamatans] = useState(false);
        const [loadingKelurahans, setLoadingKelurahans] = useState(false);
        const [showContentBillTo, setShowContentBillTo] = useState(false);
        const [showContentTaxList, setShowContentTaxList] = useState(false);
        const [showContentTotal, setShowContentTotal] = useState(false);
        const [tableData, setTableData] = useState<TableListPartInvoice[]>([]);
        const [autosaveStatus, setAutosaveStatus] = useState<'stopped' | 'processing' | 'idle' | 'error'>('stopped');
        const [selectedWorkOrder, setSelectedWorkOrder] = useState<any | null>(null);
        const selectedWorkOrderRef = useRef(selectedWorkOrder);
        selectedWorkOrderRef.current = selectedWorkOrder;
        const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
        const [isPrinting, setIsPrinting] = useState<boolean>(false);
        const [isProcessing, setIsProcessing] = useState<boolean>(false);
        const [isVoidRemarkVisible, setIsVoidRemarkVisible] = useState(false);
        const [voidRemark, setVoidRemark] = useState("Void Invoice");
        const [isReportModalOpen, setIsReportModalOpen] = useState<boolean>(false);

        const { data: idTypeData } = useSWR<IdType[]>(
            `${process.env.REACT_APP_BACKEND_URL}/api/id-type/list-data`,
            fetcher
        );

        const { data: serverDateData } = useSWR(
            `${process.env.REACT_APP_BACKEND_URL}/api/work-order-invoice/server-date`,
            fetcher,
            { revalidateOnFocus: false }
        );

        const { data: warehouseData } = useSWR<WarehouseType[]>(
            `${process.env.REACT_APP_BACKEND_URL}/api/warehouse/list-data`,
            fetcher
        );

        const { data: salesTopData } = useSWR<SalesTopType[]>(
            `${process.env.REACT_APP_BACKEND_URL}/api/sales-top/list-data`,
            fetcher
        );

        const { data: customerTypeData } = useSWR<CustomerType[]>(
            `${process.env.REACT_APP_BACKEND_URL}/api/customer-type/list-data`,
            fetcher
        );

        const { data: vatTransData } = useSWR<VatTransType[]>(
            `${process.env.REACT_APP_BACKEND_URL}/api/vat-trans/list-data`,
            fetcher
        );

        const { data: sparepartsBrandData } = useSWR<SparepartsBrandType[]>(
            `${process.env.REACT_APP_BACKEND_URL}/api/spareparts-brand/list-data`,
            fetcher
        );

        const { data: ppnData } = useSWR<PpnType>(
            `${process.env.REACT_APP_BACKEND_URL}/api/ppn/value`,
            fetcher
        );

        const warehouseMap = useMemo(() => {
            if (!warehouseData) return new Map();
            return new Map(warehouseData.map(item => [item.warehouse_code, item.warehouse_name]));
        }, [warehouseData]);

        const customerTypeMap = useMemo(() => {
            if (!customerTypeData) return new Map();
            return new Map(customerTypeData.map(item => [item.code, item.deskripsi]));
        }, [customerTypeData]);

        const idTypeMap = useMemo(() => {
            if (!idTypeData) return new Map();
            return new Map(idTypeData.map(item => [item.code, item.deskripsi]));
        }, [idTypeData]);

        const brandMap = useMemo(() => {
            if (!sparepartsBrandData) return new Map();
            return new Map(sparepartsBrandData.map(item => [item.code, item.description]));
        }, [sparepartsBrandData]);

        const salesTopOptions = useMemo(() => {
            if (!salesTopData) return [];
            return salesTopData.map(item => ({
                label: item.deskripsi,
                value: item.code,
            }));
        }, [salesTopData]);

        const vatTransOptions = useMemo(() => {
            if (!vatTransData) return [];
            return vatTransData.map(item => ({
                label: item.deskripsi,
                value: item.code,
            }));
        }, [vatTransData]);

        const autosaveTimer = useRef<NodeJS.Timeout | null>(null);
        const saveInvoiceItems = async (transId: string, items: TableListPartInvoice[]) => {
            if (!transId || items.length === 0) {
                console.log("Penyimpanan item dilewati: trans_id atau item kosong.");
                if (transId) {
                    try {
                        await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/work-order-invoice/save-items`, { trans_id: transId, items: [] });
                        console.log("Item-item invoice berhasil dihapus dari database karena daftar kosong.");
                    } catch (error) {
                        console.error("Gagal menghapus item-item invoice:", error);
                    }
                }
                return;
            }
            try {
                const payload = {
                    trans_id: transId,
                    items: items.map(item => ({
                        type: item.type,
                        job_type: item.jobType,
                        item_no: item.itemNo,
                        description: item.description,
                        qty: item.qty,
                        uom: item.uom,
                        price: item.price,
                        disc_percent: item.discPercent !== undefined && item.discPercent !== null ? String(item.discPercent) : '0',
                        disc_amount: item.discAmount,
                        total: item.total,
                        invoice_return_no: item.invoiceReturnNo,
                        status: item.status,
                        hpp: item.hpp
                    }))
                };
                await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/work-order-invoice/save-items`, payload);
                console.log("Item-item invoice berhasil disimpan ke database.");
            } catch (error) {
                console.error("Gagal menyimpan item-item invoice:", error);
            }
        };
        const saveOrUpdateInvoice = async (allValues: any) => {
            if (allValues.status !== 'Draft' && allValues.status !== '1') {
                setAutosaveStatus('stopped');
                return;
            }
            setAutosaveStatus('processing');
            try {
                const formatDateToDDMMYYYY = (dateString: string): string => {
                    const months: { [key: string]: string } = {
                        "Januari": "01", "Februari": "02", "Maret": "03", "April": "04",
                        "Mei": "05", "Juni": "06", "Juli": "07", "Agustus": "08",
                        "September": "09", "Oktober": "10", "November": "11", "Desember": "12"
                    };
                    const parts = dateString.split(' ');
                    if (parts.length !== 3) return dateString;
                    const day = parts[0].padStart(2, '0');
                    const month = months[parts[1]];
                    const year = parts[2];
                    return `${day}/${month}/${year}`;
                };

                const currentSelectedWorkOrder = selectedWorkOrderRef.current;
                if (!currentSelectedWorkOrder) {
                    console.warn("Autosave skipped: No work order selected.");
                    setAutosaveStatus('stopped');
                    return;
                }

                const payload = {
                    ...allValues,
                    status: REVERSE_STATUS_MAP[allValues.status] || allValues.status,
                    invoice_date: allValues.invoice_date ? formatDateToDDMMYYYY(allValues.invoice_date) : null,
                    brand: currentSelectedWorkOrder.brand,
                    warehouse: currentSelectedWorkOrder.warehouse,
                    customer_type: currentSelectedWorkOrder.customer_type,
                };

                await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/work-order-invoice/save`, payload);

                setAutosaveStatus('idle');
            } catch (error) {
                console.error("Autosave failed:", error);
                setAutosaveStatus('error');
            }
        };

        const onValuesChange = (_changedValues: any, allValues: any) => {
            const currentWorkOrder = allValues.work_order_no;
            const currentStatus = allValues.status;
            if (!currentWorkOrder || !selectedWorkOrderRef.current || (currentStatus !== 'Draft' && currentStatus !== '1')) {
                setAutosaveStatus('stopped');
                return;
            }

            if (_changedValues.top !== undefined || _changedValues.invoice_date !== undefined) {
                const dueDate = calculateDueDate(allValues.invoice_date, allValues.top);
                form.setFieldsValue({ due_date: dueDate });
                allValues.due_date = dueDate;
            }

            if (autosaveTimer.current) {
                clearTimeout(autosaveTimer.current);
            }

            setAutosaveStatus('processing');
            autosaveTimer.current = setTimeout(() => {
                saveOrUpdateInvoice(allValues);
            }, 500);
        };

        useEffect(() => {
            if (serverDateData) {
                form.setFieldsValue({ invoice_date: serverDateData.server_date });
            }
        }, [serverDateData, form]);

        useEffect(() => {
            const fetchProvinces = async () => {
                setLoadingProvinces(true);
                try {
                    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/so-invoice/provinces`);
                    setProvinces(response.data);
                } catch (error) {
                    console.error("Failed to fetch provinces", error);
                } finally {
                    setLoadingProvinces(false);
                }
            };
            fetchProvinces();
        }, []);

        const calculateAllTotals = (currentTableData: TableListPartInvoice[], ppnRate: number) => {
            let calculatedItemTotal = 0;
            let calculatedItemDiscount = 0;

            currentTableData.forEach(item => {
                calculatedItemTotal += item.total || 0;
                calculatedItemDiscount += Number(item.discAmount || 0);
            });
            const calculatedTotal = Math.round(calculatedItemTotal);
            const calculatedItemDiscountRounded = Math.round(calculatedItemDiscount);
            const calculatedVat = Math.round(calculatedTotal * (ppnRate / 100));
            const calculatedGrandTotal = Math.round(calculatedTotal + calculatedVat);

            return {
                calculatedItemTotal: calculatedTotal,
                calculatedItemDiscount: calculatedItemDiscountRounded,
                calculatedTotal,
                calculatedVat,
                calculatedGrandTotal,
            };
        };

        const columns: TableColumnsType<TableListPartInvoice> = [
            { title: 'Type', dataIndex: 'type', key: 'type' },
            { title: 'Job Type', dataIndex: 'jobType', key: 'jobType' },
            { title: 'Item No', dataIndex: 'itemNo', key: 'itemNo' },
            { title: 'Description', dataIndex: 'description', key: 'description' },
            { title: 'Qty', dataIndex: 'qty', key: 'qty' },
            { title: 'Uom', dataIndex: 'uom', key: 'uom' },
            {
                title: 'Price',
                dataIndex: 'price',
                key: 'price',
                align: 'right',
                render: (text: number) => text ? new Intl.NumberFormat('id-ID').format(text) : '0',
            },
            { title: 'Disc %', dataIndex: 'discPercent', key: 'discPercent' },
            {
                title: 'Disc Amount',
                dataIndex: 'discAmount',
                key: 'discAmount',
                align: 'right',
                render: (text: number) => text ? new Intl.NumberFormat('id-ID').format(text) : '0',
            },
            {
                title: 'Total',
                dataIndex: 'total',
                key: 'total',
                align: 'right',
                render: (text: number) => text ? new Intl.NumberFormat('id-ID').format(text) : '0',
            },
            { title: 'Status', dataIndex: 'status', key: 'status' },
            { title: 'Invoice Return No', dataIndex: 'invoiceReturnNo', key: 'invoiceReturnNo' },
        ];

        const initialValues = {
            status: "Draft",
        };

        const showModal = () => setIsModalVisible(true);
        const handleCancel = () => setIsModalVisible(false);

        const resetFormAndData = () => {
            form.resetFields();
            form.setFieldsValue({
                status: "Draft",
                invoice_date: serverDateData?.server_date || ""
            });
            setTableData([]);
            setSelectedRowKeys([]);
            setSelectedWorkOrder(null);
            setShowContentBillTo(false);
            setShowContentTaxList(false);
            setShowContentTotal(false);
            setAutosaveStatus('stopped');
            mutate(`${process.env.REACT_APP_BACKEND_URL}/api/work-order-invoice/list-data`);
        };

        const handleNew = () => {
            resetFormAndData();
            notification.success({
                message: 'Reset Form Success',
            });
        };

        const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
            setSelectedRowKeys(newSelectedRowKeys);
        };

        const submitVoidWithRemark = async () => {
            const transId = form.getFieldValue('trans_id');
            setIsProcessing(true);
            try {
                await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/work-order-invoice/void/${transId}`, {
                    data: {
                        remark: voidRemark,
                        request_by: userData?.kode_grup1
                    }
                });
                setIsVoidRemarkVisible(false);
                notification.success({ message: 'Berhasil', description: 'Permintaan Invoice dibatalkan (Void) sedang menunggu approve.' });
                resetFormAndData();
            } catch (error: any) {
                notification.error({ message: 'Gagal', description: error.response?.data?.error || "Gagal void." });
            } finally {
                setIsProcessing(false);
            }
        };

        const handleVoid = () => {
            const transId = form.getFieldValue('trans_id');
            if (!transId) return;
            const currentStatus = form.getFieldValue('status');
            const invoiceDateStr = form.getFieldValue('invoice_date');

            if (currentStatus === 'Active' || currentStatus === '22') {
                const now = new Date();
                const currentMonth = now.getMonth();
                const currentYear = now.getFullYear();

                let invoiceMonth = -1;
                let invoiceYear = -1;

                if (invoiceDateStr && invoiceDateStr.includes('/')) {
                    const parts = invoiceDateStr.split('/');
                    if (parts.length === 3) {
                        invoiceMonth = parseInt(parts[1], 10) - 1;
                        invoiceYear = parseInt(parts[2], 10);
                    }
                } else if (invoiceDateStr && invoiceDateStr.includes(' ')) {
                    const monthsMap: { [key: string]: number } = {
                        "Januari": 0, "Februari": 1, "Maret": 2, "April": 3, "Mei": 4, "Juni": 5,
                        "Juli": 6, "Agustus": 7, "September": 8, "Oktober": 9, "November": 10, "Desember": 11
                    };
                    const parts = invoiceDateStr.split(' ');
                    if (parts.length === 3) {
                        invoiceMonth = monthsMap[parts[1]];
                        invoiceYear = parseInt(parts[2], 10);
                    }
                }

                if (invoiceMonth !== currentMonth || invoiceYear !== currentYear) {
                    Modal.error({
                        title: 'Peringatan',
                        content: 'Invoice tidak dapat di void karena beda bulan, hubungi Administrator',
                        okText: 'OK',
                    });
                    return;
                }


                Modal.confirm({
                    title: 'Konfirmasi',
                    content: 'Apakah anda yakin membatalkan invoice ?',
                    okText: 'Ya',
                    cancelText: 'Tidak',
                    onOk: () => {
                        setVoidRemark("Void Invoice");
                        setIsVoidRemarkVisible(true);
                    }
                });
                return;
            } else {

                Modal.confirm({
                    title: 'Konfirmasi',
                    content: 'Yakin untuk void?',
                    okText: 'Ya',
                    cancelText: 'Tidak',
                    onOk: async () => {
                        setIsProcessing(true);
                        try {
                            await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/work-order-invoice/void/${transId}`);
                            resetFormAndData();
                        } catch (error: any) {
                            notification.error({ message: 'Gagal', description: "Gagal melakukan void." });
                        } finally {
                            setIsProcessing(false);
                        }
                    },
                });
            }
        };

        const handleDeleteSelectedItems = async () => {
            if (selectedRowKeys.length === 0) {
                return;
            }

            const newTableData = tableData.filter(item => !selectedRowKeys.includes(item.id));
            setTableData(newTableData);
            setSelectedRowKeys([]);
            const ppnRate = ppnData && ppnData.value ? parseFloat(ppnData.value) : 0;

            const {
                calculatedItemTotal,
                calculatedItemDiscount,
                calculatedTotal,
                calculatedVat,
                calculatedGrandTotal,
            } = calculateAllTotals(newTableData, ppnRate);

            form.setFieldsValue({
                item_total: calculatedItemTotal,
                item_discount: calculatedItemDiscount,
                total: calculatedTotal,
                vat: calculatedVat,
                grand_total: calculatedGrandTotal,
            });

            const currentTransId = form.getFieldValue('trans_id');
            if (currentTransId) {
                await saveInvoiceItems(currentTransId, newTableData);
                const allFormValues = form.getFieldsValue(true);
                await saveOrUpdateInvoice(allFormValues);
            } else {

            }
        };

        const handleSubmit = async () => {
            try {
                await form.validateFields();
                const allValues = form.getFieldsValue(true);
                if (!allValues.work_order_no) return;

                Modal.confirm({
                    title: 'Konfirmasi',
                    content: 'Apakah data sudah benar untuk menerbitkan invoice?',
                    okText: 'Ya',
                    cancelText: 'Tidak',
                    onOk: async () => {
                        setIsProcessing(true);
                        try {
                            const payload = {
                                ...allValues,
                                status: '22'
                            };
                            const submitResponse = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/work-order-invoice/submit`, { trans_id: allValues.trans_id });
                            const generatedInvoiceNo = submitResponse.data.invoice_no;
                            form.setFieldsValue({ status: 'Active', invoice_no: generatedInvoiceNo });
                            setAutosaveStatus('stopped');
                            notification.success({
                                message: 'Berhasil',
                                description: 'Invoice berhasil diterbitkan.',
                                placement: 'topRight',
                            });
                        } catch (error) {
                            notification.error({
                                message: 'Gagal',
                                description: 'Gagal menerbitkan invoice.',
                                placement: 'topRight',
                            });
                        } finally {
                            setIsProcessing(false);
                        }
                    },
                });
            } catch (errorInfo: any) {
                if (errorInfo?.errorFields?.length > 0) {
                    errorInfo.errorFields.forEach((field: any) => {
                        const fieldName = field.name[0];
                        if (fieldName === 'top') {
                            setShowContentBillTo(true);
                        }
                        if (['npwp', 'trans_code'].includes(fieldName)) {
                            setShowContentTaxList(true);
                        }
                    });
                    setTimeout(() => {
                        form.scrollToField(errorInfo.errorFields[0].name);
                    }, 100);
                }
            }
        };

        const handlePrintInvoice = async () => {
            const transId = form.getFieldValue('trans_id');
            if (!transId) {
                notification.warning({ message: "Trans ID tidak ditemukan untuk dicetak." });
                return;
            }
            setIsPrinting(true);
            try {
                const dataResponse = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/work-order-invoice/print/${encodeURIComponent(transId)}`);
                const { invoice, requests, items, server_time } = dataResponse.data;
                const PAYMENT_TYPES: Record<string, string> = {
                    "1": "Cash", "2": "Cheque", "3": "Credit Card", "4": "Debit Card",
                    "5": "E-Banking", "6": "Giro", "7": "Other", "8": "Transfer",
                    "9": "Travel Cheque", "10": "Voucher"
                };
                const paymentLabel = PAYMENT_TYPES[String(invoice.payment_type)] || invoice.payment_type || "-";
                const statusLabel = STATUS_MAP[String(invoice.status)] || invoice.status || "-";
                const totalJasa = Math.round(items.filter((i: any) => String(i.type) === '4').reduce((a: number, b: any) => a + (Number(b.total) || 0), 0));
                const totalSparepart = Math.round(items.filter((i: any) => String(i.type) === '1').reduce((a: number, b: any) => a + ((Number(b.price) * Number(b.qty)) - (Number(b.disc_amount) * Number(b.qty))), 0));
                const topLabel = salesTopData?.find(item => item.code === String(invoice.top))?.deskripsi || invoice.top || '-';
                const reportPayload = {
                    Header: [{
                        customer: invoice.customer || '-',
                        address_bill: invoice.address_bill || '-',
                        phone_no_bill: invoice.phone_no_bill || '-',
                        npwp: invoice.npwp || '-',
                        warehouse: invoice.warehouse || '-',
                        warehouse_label: getWarehouseLabel(invoice.warehouse),
                        no_polisi: invoice.no_polisi || '-',
                        chassis_no: invoice.chassis_no || '-',
                        engine_no: invoice.engine_no_detail || '-',
                        mileage: invoice.current_milage || '-',
                        unit_purchase_date: invoice.invoice_date || '-',
                        service_advisor: invoice.service_advisor || '-',
                        invoice_no: invoice.invoice_no || '-',
                        invoice_date: invoice.invoice_date || '-',
                        payment_type: paymentLabel,
                        work_order_no: invoice.work_order_no || '-',
                        work_order_date: invoice.work_order_date || '-',
                        status: statusLabel,
                        po_customer: invoice.po_customer || '-',
                        amount_in_words: terbilang(Math.round(invoice.grand_total || 0)),
                        top: topLabel,
                        due_date: invoice.due_date || '-',
                        total_jasa: totalJasa,
                        total_sparepart: totalSparepart,
                        subtotal: Math.round(Number(invoice.item_total || 0)),
                        ppn: Math.round(Number(invoice.vat || 0)),
                        grand_total: Math.round(Number(invoice.grand_total || 0)),
                        server_time: server_time || ''
                    }],
                    Requests: (requests || []).map((req: any, idx: number) => ({
                        no: idx + 1,
                        request: req.request || ''
                    })),
                    Operations: (items || []).filter((i: any) => String(i.type) === '4').map((item: any, idx: number) => ({
                        no: idx + 1,
                        item_code: item.item_no || '',
                        description: item.description || '',
                        qty: Number(item.qty) || 0,
                        unit_price: Number(item.price) || 0,
                        disc_percent: Number(item.disc_percent) || 0,
                        disc_amount: Number(item.disc_amount) || 0,
                        total: Number(item.total) || 0
                    })),
                    Spareparts: (items || []).filter((i: any) => String(i.type) === '1').map((item: any, idx: number) => ({
                        no: idx + 1,
                        item_code: item.item_no || '',
                        description: item.description || '',
                        qty: Number(item.qty) || 0,
                        unit_price: Number(item.price) || 0,
                        disc_percent: Number(item.disc_percent) || 0,
                        disc_amount: Number(item.disc_amount) || 0,
                        total: Number(item.total) || 0
                    }))
                };
                await import("stimulsoft-reports-js/Css/stimulsoft.viewer.office2013.whiteblue.css");
                await import("stimulsoft-reports-js/Scripts/stimulsoft.reports");
                const viewerModule = await import("stimulsoft-reports-js/Scripts/stimulsoft.viewer");
                const Stimulsoft = viewerModule.Stimulsoft || (window as any).Stimulsoft;
                StartLicense(Stimulsoft);
                setIsReportModalOpen(true);
                setTimeout(() => {
                    const report = Stimulsoft.Report.StiReport.createNewReport();
                    report.loadFile("/reports/wo_invoice/work_order_invoice.mrt");
                    const dataSet = new Stimulsoft.System.Data.DataSet("ReportData");
                    dataSet.readJson(reportPayload);
                    report.regData(dataSet.dataSetName, "", dataSet);
                    report.dictionary.synchronize();
                    const options = new Stimulsoft.Viewer.StiViewerOptions();
                    options.toolbar.showOpenButton = true;
                    const viewer = new Stimulsoft.Viewer.StiViewer(options, "StiViewer", false);
                    (viewer as any).onOpenReport = (args: any) => {
                        const newReport = args.report;
                        if (newReport) {
                            newReport.regData(dataSet.dataSetName, "", dataSet);
                            newReport.dictionary.synchronize();
                            viewer.report = newReport;
                        }
                    };
                    viewer.report = report;
                    viewer.renderHtml("sti-viewer-container");
                }, 300);
            } catch (error) {
                console.error("Gagal memuat Stimulsoft Report:", error);
                notification.error({ message: "Gagal memuat preview laporan Stimulsoft." });
            } finally {
                setIsPrinting(false);
            }
        };

        const handleReportModalCancel = () => {
            setIsReportModalOpen(false);
        };

        const handleWorkOrderSelect = async (record: any) => {
            setIsProcessing(true);
            console.log("[FRONTEND HOC] handleWorkOrderSelect called with record:", record);
            setSelectedWorkOrder(record);
            const warehouseName = warehouseMap.get(record.warehouse) || record.warehouse;
            const customerTypeDesc = customerTypeMap.get(record.customer_type) || record.customer_type;
            const brandDescription = brandMap.get(record.brand) || record.brand;
            const idTypeDesc = idTypeMap.get(record.id_type) || record.id_type;
            const computedDueDate = calculateDueDate(record.invoice_date || serverDateData?.server_date, record.top || undefined);
            let currentTransId = record.trans_id;
            if (!currentTransId) {
                const transIdResponse = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/work-order-invoice/generate-trans-id`);
                currentTransId = transIdResponse.data.trans_id;
            }
            form.setFieldsValue({
                status: STATUS_MAP[record.invoice_status] || STATUS_MAP[record.status] || "Draft",
                trans_id: currentTransId,
                invoice_date: record.invoice_date || serverDateData?.server_date,
                due_date: computedDueDate,
                brand: brandDescription,
                work_order_no: record.work_order_no,
                warehouse: warehouseName,
                customer: record.customer || record.bill_to_name,
                no_polisi: record.no_polisi,
                chassis_no: record.chassis_no,
                service_advisor: record.service_advisor,
                contact_service_no: record.contact_service_no || "",
                po_customer: record.po_customer || "",
                recommendation: record.recommendation || "",
                payment_type: record.payment_type || undefined,
                customer_code: record.customer_code || record.bill_to_code,
                customer_type: customerTypeDesc,
                title_prefix: record.title_prefix || record.title_p,
                customer_name: record.customer_name || record.bill_to_name,
                title_suffix: record.title_suffix || record.title_s,
                id_type: idTypeDesc,
                id_no: record.id_no,
                bill_to: record.bill_to || record.name_billing,
                address_bill: record.address_bill || record.address_billing,
                provinsi_bill: record.provinsi_bill || record.provinsi_billing,
                kabupaten_bill: record.kabupaten_bill || record.kabupaten_billing,
                kecamatan_bill: record.kecamatan_bill || record.kecamatan_billing,
                kelurahan_bill: record.kelurahan_bill || record.kelurahan_billing,
                kode_pos_bill: record.kode_pos_bill || record.kode_pos_billing,
                phone_no_bill: record.phone_no_bill || record.phone_contact,
                top: record.termofpayment || record.top || undefined,
                npwp: record.npwp || record.no_id_billing,
                trans_code: record.trans_code || undefined,
                name_npwp: record.name_npwp || record.vatname,
                address_npwp: record.address_npwp || record.vat_address1,
            });

            if (record.bill_to_code || record.customer_code) {
                setShowContentBillTo(true);
            }
            if (record.no_id_billing) {
                setShowContentTaxList(true);
            }

            if (record.work_order_no) {
                try {
                    form.setFieldsValue({ invoice_no: record.invoice_no || "" });
                    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/work-order-invoice/items/${record.work_order_no}?trans_id=${currentTransId}`); // ✅: fetch associated items by trans_id parameter
                    console.log("[FRONTEND HOC] Items response data:", response.data);
                    const items = response.data.map((item: any, index: number) => ({
                        id: item.id || `${item.item_code || 'item'}_${index}`,
                        key: item.id || `${item.item_code || 'item'}_${index}`,
                        type: item.type,
                        jobType: item.job_type,
                        itemNo: item.item_code,
                        description: item.item_name,
                        qty: item.type === '4' ? parseDecimalNumber(item.qty) : parseIndonesianNumber(item.supply_qty),
                        uom: item.uom,
                        price: parseFloat(item.price) || 0,
                        discPercent: item.disc_percent !== null && item.disc_percent !== undefined ? String(item.disc_percent) : '0',
                        discAmount: parseFloat(item.disc_amount) || 0,
                        total: item.type === '1' ? ((parseFloat(item.price) || 0) * parseIndonesianNumber(item.supply_qty)) - ((parseFloat(item.disc_amount) || 0) * parseIndonesianNumber(item.supply_qty)) : (parseFloat(item.total) || 0),
                        status: item.status,
                        invoiceReturnNo: item.invoice_return_no,
                        hpp: item.hpp || "",
                    }));
                    setTableData(items);
                    setSelectedRowKeys([]);
                    if (!record.trans_id) {
                        const allFormValues = form.getFieldsValue(true);
                        await saveOrUpdateInvoice(allFormValues);
                        await saveInvoiceItems(currentTransId, items);
                    }
                    await new Promise(resolve => setTimeout(resolve, 500));
                    const dbStatus = record.invoice_status || record.status;
                    if (dbStatus === '1' || dbStatus === 'Draft') {
                        setAutosaveStatus('idle');
                    } else {
                        setAutosaveStatus('stopped');
                    }
                    const ppnRate = ppnData && ppnData.value ? parseFloat(ppnData.value) : 0;
                    const {
                        calculatedItemTotal,
                        calculatedItemDiscount,
                        calculatedTotal,
                        calculatedVat,
                        calculatedGrandTotal,
                    } = calculateAllTotals(items, ppnRate);

                    form.setFieldsValue({
                        item_total: calculatedItemTotal,
                        item_discount: calculatedItemDiscount,
                        total: calculatedTotal,
                        vat: calculatedVat,
                        grand_total: calculatedGrandTotal,
                    });


                    if (items.length > 0) {
                        setShowContentTotal(true);
                    } else {
                        setShowContentTotal(false);
                    }


                } catch (error) {
                    console.error("Failed to fetch work order items or generate invoice no", error);
                    setTableData([]);
                    setSelectedRowKeys([]);


                    form.setFieldsValue({
                        item_total: 0,
                        item_discount: 0,
                        total: 0,
                        vat: 0,
                        grand_total: 0,
                    });
                    setShowContentTotal(false);

                }
            } else {
                setTableData([]);
                setSelectedRowKeys([]);


                form.setFieldsValue({
                    item_total: 0,
                    item_discount: 0,
                    total: 0,
                    vat: 0,
                    grand_total: 0,
                });
                setShowContentTotal(false);

            }

            if (record.provinsi_billing) {
                setLoadingRegencies(true);
                try {
                    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/so-invoice/regencies/${record.provinsi_billing}`);
                    setRegencies(response.data);
                } catch (error) { console.error("Failed to fetch regencies", error); } finally { setLoadingRegencies(false); }
            }
            if (record.kabupaten_billing) {
                setLoadingKecamatans(true);
                try {
                    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/so-invoice/kecamatans/${record.kabupaten_billing}`);
                    setKecamatans(response.data);
                } catch (error) { console.error("Failed to fetch kecamatans", error); } finally { setLoadingKecamatans(false); }
            }
            if (record.kecamatan_billing) {
                setLoadingKelurahans(true);
                try {
                    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/so-invoice/kelurahans/${record.kecamatan_billing}`);
                    setKelurahans(response.data);
                } catch (error) { console.error("Failed to fetch kelurahans", error); } finally { setLoadingKelurahans(false); }
            }
            setIsProcessing(false);
            handleCancel();
        };

        useEffect(() => {
            const loadDataFromNavigation = async () => {
                console.log("[FRONTEND HOC] loadDataFromNavigation triggered. State:", location.state);
                const searchParams = new URLSearchParams(location.search);
                const transIdFromUrl = searchParams.get('transId');

                if (location.state?.transId || transIdFromUrl) {
                    try {
                        const targetId = location.state?.transId || transIdFromUrl;
                        console.log("[FRONTEND HOC] Fetching invoice details for:", targetId);
                        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/work-order-invoice/list-invoice?trans_id=${targetId}`);

                        console.log("[FRONTEND HOC] Invoice response data:", response.data);
                        const fullRecord = response.data[0];
                        if (fullRecord) {
                            console.log("[FRONTEND HOC] Invoice record found. Loading into form...", fullRecord);
                            handleWorkOrderSelect({
                                ...fullRecord,
                                invoice_status: location.state?.invoiceStatus || fullRecord.status,
                                trans_id: targetId,
                                npwp: location.state?.npwp || fullRecord.npwp
                            });
                            console.log("[FRONTEND HOC] handleWorkOrderSelect successfully executed.");
                        } else {
                            console.warn("[FRONTEND HOC] No invoice record found in database for transId:", location.state.transId);
                        }
                    } catch (error) {
                        console.error("Gagal memuat data dari navigasi:", error);
                    }
                }
            };
            loadDataFromNavigation();
        }, [location.state]);

        const onChangeProvince = async (provinceCode: string) => {
            form.setFieldsValue({ kabupaten_bill: null, kecamatan_bill: null, kelurahan_bill: null, kode_pos_bill: null });
            setRegencies([]);
            setKecamatans([]);
            setKelurahans([]);
            if (provinceCode) {
                setLoadingRegencies(true);
                try {
                    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/so-invoice/regencies/${provinceCode}`);
                    setRegencies(response.data);
                } catch (error) { console.error("Failed to fetch regencies", error); } finally { setLoadingRegencies(false); }
            }
        };

        const onChangeRegency = async (regencyCode: string) => {
            form.setFieldsValue({ kecamatan_bill: null, kelurahan_bill: null, kode_pos_bill: null });
            setKecamatans([]);
            setKelurahans([]);
            if (regencyCode) {
                setLoadingKecamatans(true);
                try {
                    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/so-invoice/kecamatans/${regencyCode}`);
                    setKecamatans(response.data);
                } catch (error) { console.error("Failed to fetch kecamatans", error); } finally { setLoadingKecamatans(false); }
            }
        };

        const onChangeKecamatan = async (kecamatanCode: string) => {
            form.setFieldsValue({ kelurahan_bill: null, kode_pos_bill: null });
            setKelurahans([]);
            if (kecamatanCode) {
                setLoadingKelurahans(true);
                try {
                    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/so-invoice/kelurahans/${kecamatanCode}`);
                    setKelurahans(response.data);
                } catch (error) { console.error("Failed to fetch kelurahans", error); } finally { setLoadingKelurahans(false); }
            }
        };

        const onChangeKelurahan = async (kelurahanCode: string) => {
            form.setFieldsValue({ kode_pos_bill: null });
            if (kelurahanCode) {
                try {
                    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/so-invoice/postal-code/${kelurahanCode}`);
                    form.setFieldsValue({ kode_pos_bill: response.data.postalCode });
                } catch (error) { console.error("Failed to fetch postal code", error); }
            }
        };

        const handleRefresh = async () => {
            const workOrderNo = form.getFieldValue('work_order_no');
            if (!workOrderNo) {
                notification.warning({
                    message: 'Peringatan',
                    description: 'Tidak ada Work Order No yang dapat direfresh.',
                });
                return;
            }
            try {
                setIsProcessing(true);
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/work-order-invoice/list-data`);
                const records = response.data;
                const matchingRecord = records.find((rec: any) => rec.work_order_no === workOrderNo);
                if (matchingRecord) {
                    const currentValues = form.getFieldsValue();
                    const mergedRecord = {
                        ...matchingRecord,
                        trans_id: currentValues.trans_id || matchingRecord.trans_id,
                        invoice_no: currentValues.invoice_no || matchingRecord.invoice_no,
                        invoice_status: REVERSE_STATUS_MAP[currentValues.status] || currentValues.status || matchingRecord.invoice_status,
                        contact_service_no: currentValues.contact_service_no || matchingRecord.contact_service_no || "",
                        po_customer: currentValues.po_customer || matchingRecord.po_customer || "",
                        recommendation: currentValues.recommendation || matchingRecord.recommendation || "",
                        payment_type: currentValues.payment_type || matchingRecord.payment_type || undefined,
                        phone_no_bill: currentValues.phone_no_bill || matchingRecord.phone_no_bill || matchingRecord.phone_contact,
                        termofpayment: currentValues.top || matchingRecord.termofpayment,
                        top: currentValues.top || matchingRecord.top || undefined,
                        no_id_billing: currentValues.npwp || matchingRecord.no_id_billing,
                        npwp: currentValues.npwp || matchingRecord.no_id_billing,
                        vatnpwp: currentValues.npwp || matchingRecord.no_id_billing,
                        trans_code: currentValues.trans_code || matchingRecord.trans_code || undefined,
                        name_npwp: currentValues.name_npwp || matchingRecord.name_npwp || matchingRecord.vatname,
                        vatname: currentValues.name_npwp || matchingRecord.vatname,
                        address_npwp: currentValues.address_npwp || matchingRecord.address_npwp || matchingRecord.vat_address1,
                        vat_address1: currentValues.address_npwp || matchingRecord.vat_address1,
                    };
                    setSelectedWorkOrder(mergedRecord);
                    const warehouseName = warehouseMap.get(mergedRecord.warehouse) || mergedRecord.warehouse;
                    const customerTypeDesc = customerTypeMap.get(mergedRecord.customer_type) || mergedRecord.customer_type;
                    const brandDescription = brandMap.get(mergedRecord.brand) || mergedRecord.brand;
                    const idTypeDesc = idTypeMap.get(mergedRecord.id_type) || mergedRecord.id_type;
                    const computedDueDate = calculateDueDate(mergedRecord.invoice_date || serverDateData?.server_date, mergedRecord.top || undefined);
                    form.setFieldsValue({
                        status: STATUS_MAP[mergedRecord.invoice_status] || STATUS_MAP[mergedRecord.status] || "Draft",
                        trans_id: mergedRecord.trans_id,
                        invoice_date: mergedRecord.invoice_date || serverDateData?.server_date,
                        due_date: computedDueDate,
                        brand: brandDescription,
                        work_order_no: mergedRecord.work_order_no,
                        warehouse: warehouseName,
                        customer: mergedRecord.customer || mergedRecord.bill_to_name,
                        no_polisi: mergedRecord.no_polisi,
                        chassis_no: mergedRecord.chassis_no,
                        service_advisor: mergedRecord.service_advisor,
                        contact_service_no: mergedRecord.contact_service_no || "",
                        po_customer: mergedRecord.po_customer || "",
                        recommendation: mergedRecord.recommendation || "",
                        payment_type: mergedRecord.payment_type || undefined,
                        customer_code: mergedRecord.customer_code || mergedRecord.bill_to_code,
                        customer_type: customerTypeDesc,
                        title_prefix: mergedRecord.title_prefix || mergedRecord.title_p,
                        customer_name: mergedRecord.customer_name || mergedRecord.bill_to_name,
                        title_suffix: mergedRecord.title_suffix || mergedRecord.title_s,
                        id_type: idTypeDesc,
                        id_no: mergedRecord.id_no,
                        bill_to: mergedRecord.bill_to || mergedRecord.name_billing,
                        address_bill: mergedRecord.address_bill || mergedRecord.address_billing,
                        provinsi_bill: mergedRecord.provinsi_bill || mergedRecord.provinsi_billing,
                        kabupaten_bill: mergedRecord.kabupaten_bill || mergedRecord.kabupaten_billing,
                        kecamatan_bill: mergedRecord.kecamatan_bill || mergedRecord.kecamatan_billing,
                        kelurahan_bill: mergedRecord.kelurahan_bill || mergedRecord.kelurahan_billing,
                        kode_pos_bill: mergedRecord.kode_pos_bill || mergedRecord.kode_pos_billing,
                        phone_no_bill: mergedRecord.phone_no_bill || mergedRecord.phone_contact,
                        top: mergedRecord.termofpayment || mergedRecord.top || undefined,
                        npwp: mergedRecord.npwp || mergedRecord.no_id_billing,
                        trans_code: mergedRecord.trans_code || undefined,
                        name_npwp: mergedRecord.name_npwp || mergedRecord.vatname,
                        address_npwp: mergedRecord.address_npwp || mergedRecord.vat_address1,
                        invoice_no: mergedRecord.invoice_no || ""
                    });
                    const itemsResponse = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/work-order-invoice/items/${mergedRecord.work_order_no}`);
                    const items = itemsResponse.data.map((item: any, index: number) => ({
                        id: item.id || `${item.item_code || 'item'}_${index}`,
                        key: item.id || `${item.item_code || 'item'}_${index}`,
                        type: item.type,
                        jobType: item.job_type,
                        itemNo: item.item_code,
                        description: item.item_name,
                        qty: item.type === '4' ? parseDecimalNumber(item.qty) : parseIndonesianNumber(item.supply_qty),
                        uom: item.uom,
                        price: parseFloat(item.price) || 0,
                        discPercent: item.disc_percent !== null && item.disc_percent !== undefined ? String(item.disc_percent) : '0',
                        discAmount: parseFloat(item.disc_amount) || 0,
                        total: item.type === '1' ? ((parseFloat(item.price) || 0) * parseIndonesianNumber(item.supply_qty)) - ((parseFloat(item.disc_amount) || 0) * parseIndonesianNumber(item.supply_qty)) : (parseFloat(item.total) || 0),
                        status: item.status,
                        invoiceReturnNo: item.invoice_return_no,
                        hpp: item.hpp || "",
                    }));
                    setTableData(items);
                    setSelectedRowKeys([]);
                    const ppnRate = ppnData && ppnData.value ? parseFloat(ppnData.value) : 0;
                    const { calculatedItemTotal, calculatedItemDiscount, calculatedTotal, calculatedVat, calculatedGrandTotal } = calculateAllTotals(items, ppnRate);
                    form.setFieldsValue({
                        item_total: calculatedItemTotal,
                        item_discount: calculatedItemDiscount,
                        total: calculatedTotal,
                        vat: calculatedVat,
                        grand_total: calculatedGrandTotal,
                    });
                    setShowContentTotal(items.length > 0);
                    if (mergedRecord.trans_id) {
                        await saveInvoiceItems(mergedRecord.trans_id, items);
                        const allFormValues = form.getFieldsValue(true);
                        await saveOrUpdateInvoice(allFormValues);
                    }
                    notification.success({
                        message: 'Berhasil',
                        description: 'Data berhasil direfresh.',
                    });
                } else {
                    notification.warning({
                        message: 'Gagal',
                        description: 'Data Work Order tidak ditemukan.',
                    });
                }
            } catch (error) {
                console.error("Failed to refresh work order:", error);
                notification.error({
                    message: 'Gagal',
                    description: 'Gagal merefresh data.',
                });
            } finally { // ⚠️: tambahkan penanganan blok finally
                setIsProcessing(false); // ⚠️: nonaktifkan status loading proses
            }
        };

        if (!serverDateData) return <Spin spinning={true} fullscreen tip="Initializing Work Order Invoice..." />;

        return <Component
            {...props}
            form={form}
            isModalVisible={isModalVisible}
            showModal={showModal}
            handleCancel={handleCancel}
            handleNew={handleNew}
            handleWorkOrderSelect={handleWorkOrderSelect}
            initialValues={initialValues}
            columns={columns}
            data={tableData}
            salesTopOptions={salesTopOptions}
            provinceOptions={provinces}
            regencyOptions={regencies}
            kecamatanOptions={kecamatans}
            kelurahanOptions={kelurahans}
            loadingProvinces={loadingProvinces}
            loadingRegencies={loadingRegencies}
            loadingKecamatans={loadingKecamatans}
            loadingKelurahans={loadingKelurahans}
            onChangeProvince={onChangeProvince}
            onChangeRegency={onChangeRegency}
            onChangeKecamatan={onChangeKecamatan}
            onChangeKelurahan={onChangeKelurahan}
            showContentBillTo={showContentBillTo}
            setShowContentBillTo={setShowContentBillTo}
            showContentTaxList={showContentTaxList}
            setShowContentTaxList={setShowContentTaxList}
            showContentTotal={showContentTotal}
            setShowContentTotal={setShowContentTotal}
            vatTransOptions={vatTransOptions}
            autosaveStatus={autosaveStatus}
            onValuesChange={onValuesChange}
            selectedRowKeys={selectedRowKeys}
            setSelectedRowKeys={setSelectedRowKeys}
            onSelectChange={onSelectChange}
            handleDeleteSelectedItems={handleDeleteSelectedItems}
            handleVoid={handleVoid}
            handleSubmit={handleSubmit}
            handlePrintInvoice={handlePrintInvoice}
            isPrinting={isPrinting}
            isProcessing={isProcessing}
            isVoidRemarkVisible={isVoidRemarkVisible}
            setIsVoidRemarkVisible={setIsVoidRemarkVisible}
            voidRemark={voidRemark}
            setVoidRemark={setVoidRemark}
            submitVoidWithRemark={submitVoidWithRemark}
            handleRefresh={handleRefresh}
            isReportModalOpen={isReportModalOpen}
            handleReportModalCancel={handleReportModalCancel}
        />;
    };
};
